import { IPagesWithCategories } from "@/interfaces/page"
import { IPageBgImage } from "@/interfaces/page"
import ProcessImageWithOpacity from "@/lib/ProcessImageWithOpacity"

export const DistributePages = (pages: IPagesWithCategories[]) => {

    const NUMBER_OF_MAIN_PAGES_TO_BE_DISPLAYED: number = 6
    const LENGTH_OF_MAIN_PAGES_MENU_STRING_TO_BE_DISPLAYED: number = 45

    let mainPages: IPagesWithCategories[] = []
    let wrappedPages: IPagesWithCategories[] = []
    let mainPagesMenu: string[] = []

    const is_main_pages_full = () => {

        return mainPagesMenu.length >= NUMBER_OF_MAIN_PAGES_TO_BE_DISPLAYED ||
            mainPagesMenu.join('').length >= LENGTH_OF_MAIN_PAGES_MENU_STRING_TO_BE_DISPLAYED
    }

    pages.forEach( ( page: IPagesWithCategories ) => {
        let pageName = page.isCategory ? page.categoryName : (page.name || page.menu)
        mainPagesMenu.push(pageName)
        is_main_pages_full() ? wrappedPages.push(page) : mainPages.push(page)
    })

    return { mainPages, wrappedPages }
}

export const getHeaderBackground = ({ institutionalPageBg, homePageBg, isHomePage, isInstitutionalPage }: GetHeaderBackgroundProps) => {
    if(isHomePage){
        return { backgroundImage: homePageBg }
    }else if(isInstitutionalPage){

        const backgroundImage = institutionalPageBg ? ProcessImageWithOpacity({url: institutionalPageBg.url!, opacity: institutionalPageBg.opacity!}) : ''

        return { backgroundImage }
    }else{
        return { backgroundImage: ''}
    }
}

export const addExternalLinksFlag = (externalLinks: IPagesWithCategories[]) => {
    return externalLinks.map( (link) => ({
        ...link,
        isExternalLink: true
    }))
}

interface GetHeaderBackgroundProps{
    institutionalPageBg: IPageBgImage | undefined;
    homePageBg: string | undefined;
    isHomePage: boolean | undefined;
    isInstitutionalPage: boolean | undefined;
}